(function(EF) {

  var Resource = Chaplin.Model.extend({
    initialize: function(attributes, options) {
      this.enrollment = options.enrollment;
    },
    url: function() {
        return EF.url('/sdk/enrollments/' + this.enrollment.get('id') +'/resources/' + this.get('id') + '.json');
    }
  });

  _.extend(EF.Models, {
    Resource: Resource
  });

}(EF));
